'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FieldErrorWrapper = require('./components/FieldErrorWrapper.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FieldErrorWrapper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-field-error-wrapper/lib/index.js
// module id = 366
// module chunks = 1